<template>
  
  <div class="expense-form">
    <img src="@/assets/logo.png" alt="Logo" class="form-logo">
    <h1>Alimentacion sin soporte</h1>
    <form @submit.prevent="submitExpense">

      <div class="form-group">
        <label for="maestroGasto">Maestro gasto</label>
        <v-select :options="maestroGasto" v-model="expense.maestroGasto"  label="nombreviaje" :reduce="gasto => gasto.id" @search="onGastoSearch" required/>
      </div>

      <div class="tabs">
        <button :class="{ active: activeTab === 1 }" @click.prevent="activeNewTab">Detalles de Gastos</button>
        <button :class="{ active: activeTab === 2 }" @click.prevent="activeEditTab">Gastos Enviados</button>
      </div>

      <div v-if="activeTab === 2">
          <div class="summary">
            <p>Totales</p>
            <p>Desayunos: {{ totalDesayunos }}</p>
            <p>Almuerzos: {{ totalAlmuerzos }}</p>
            <p>Cenas: {{ totalCenas }}</p>
          </div>
          <div class="summary">
            <p>Gastos pendientes: {{ totalSpentEdits }}</p>
            <button type="button" @click="sendEdit">Enviar cambios</button>
          </div>

        <div v-for="(gasto, index) in gastossubidos" :key="index" class="gasto-group">
          <h3 @click="toggleCollapseEdit(index)">
            <CircleAlert v-if="gasto.edit" class="icon-edit-true" />
            <Check v-else class="icon-edit-false" />
            Gasto enviado {{ index + 1 }}
            <Plus v-if="gasto.collapsed" class="icon-collapsed" />
            <Minus v-else class="icon-collapsed" />
          </h3>
          <div class="buttons">
            <button type="button" @click="saveEdit(index)">Guardar cambios en Gasto {{ index + 1 }}</button>
          </div>
          
          <div v-if="!gasto.collapsed">
            <div class="form-group date-input-container">
              <label for="fechagasto">Fecha del Gasto*</label>
              <input type="date" v-model="gasto.fechagasto" required />
              <span class="icon">📅</span>
            </div>
            <div class="form-group">
              <label for="ciudad">Ciudad*</label>
              <v-select :options="ciudades" v-model="gasto.ciudad" label="nombreMunicipio" required  @search="onCiudadSearch"/>
            </div>
            <div class="form-group">
              <label for="desayuno">Desayuno sin soporte</label>
              <input type="checkbox" v-model="gasto.desayuno" />
            </div>
            <div class="form-group">
              <label for="almuerzo">Almuerzo sin soporte</label>
              <input type="checkbox" v-model="gasto.almuerzo" />
            </div>
            <div class="form-group">
              <label for="cena">Cena sin soporte</label>
              <input type="checkbox" v-model="gasto.cena" />
            </div>
            <div class="form-group">
              <label for="observaciones">Observaciones</label>
              <textarea v-model="gasto.observaciones"></textarea>
            </div>
          </div>
          <hr />
        </div>
      </div>

      <div v-if="activeTab === 1">
        <div v-for="(gasto, index) in expense.gastos" :key="index" class="gasto-group">
          <h3 @click="toggleCollapse(index)">
            Gasto {{ index + 1 }}
            <Plus v-if="gasto.collapsed" class="icon-collapsed" />
            <Minus v-else class="icon-collapsed" />
          </h3>
          <div class="buttons">
            <button type="button" @click="removeGasto(index)">Eliminar Gasto</button>
          </div>
          
          <div v-if="!gasto.collapsed">
            <div class="form-group date-input-container">
              <label for="fechagasto">Fecha del Gasto*</label>
              <input type="date" v-model="gasto.fechagasto" required />
              <span class="icon">📅</span>
            </div>
            <div class="form-group">
              <label for="ciudad">Ciudad*</label>
              <v-select :options="ciudades" v-model="gasto.ciudad" label="nombreMunicipio" required :reduce="ciudad => ciudad.id" @search="onCiudadSearch"/>
            </div>
            <div class="form-group">
              <label for="desayuno">Desayuno sin soporte</label>
              <input type="checkbox" v-model="gasto.desayuno" />
            </div>
            <div class="form-group">
              <label for="almuerzo">Almuerzo sin soporte</label>
              <input type="checkbox" v-model="gasto.almuerzo" />
            </div>
            <div class="form-group">
              <label for="cena">Cena sin soporte</label>
              <input type="checkbox" v-model="gasto.cena" />
            </div>
            <div class="form-group">
              <label for="observaciones">Observaciones</label>
              <textarea v-model="gasto.observaciones"></textarea>
            </div>
          </div>
          <hr />
        </div>
        <div class="buttons">
          <button type="button" @click="addGasto">Agregar detalle al gasto</button>
          <button type="submit">Subir Gastos</button>
        </div>
      </div>

    </form>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import {updateGCS2, insertarDetalleGCS, selectDepartamentos, selectMaestroGastos, tokenValidation, selectSpentDetailEdit, editSpents} from '@/api/api';
import { Plus, Minus, Check, CircleAlert } from 'lucide-vue-next'; "lucide-vue-next";

export default {
  name: 'alimentacionSinSoporte',
  components: {
    vSelect,
    Plus,
    Minus,
    Check,
    CircleAlert
  },
  data() {
    return {
      tableType: "ass",
      activeTab: 1,
      expense: {
        gastos: [],
        maestroGasto: null,
      },
      maestroGasto: [],
      ciudades: [],
      correousuario: '',
      gastossubidos: [],
      spentsedits: [],
      uploading: false,
    };
  },
  mounted() {
    this.reloadPage();
    this.fetchCiudades();
    this.fecthGastos();
  },
  watch: {
    'expense.maestroGasto'() {
      this.fecthExpenses();
    }
  },
  computed: {
    totalSpentEdits() {
      return this.spentsedits.length;
    },
    totalDesayunos() {
      return this.gastossubidos.reduce((sum, gasto) => sum + (gasto.desayuno ? 1 : 0), 0);
    },
    totalAlmuerzos() {
      return this.gastossubidos.reduce((sum, gasto) => sum + (gasto.almuerzo ? 1 : 0), 0);
    },
    totalCenas() {
      return this.gastossubidos.reduce((sum, gasto) => sum + (gasto.cena ? 1 : 0), 0);
    }
  },
  created() {
    this.fetchCiudades();
  },
  methods: {
    checkRepeat() {
      if (this.gastossubidos.length > 0) {
        for (let gasto in this.expense.gastos) {
          for (let editGasto in this.gastossubidos) {
            if (this.expense.gastos[gasto].fechagasto == this.gastossubidos[editGasto].fechagasto && this.expense.gastos[gasto].ciudad == this.gastossubidos[editGasto].ciudad.id) {
              return true
            }
          }
        }
      }
      return false;
    },
    saveEdit(index) {
      const gastoEditado = this.gastossubidos[index];

      // Verificar si el gasto ya está en la lista de editados
      if (this.spentsedits.length == 0) {
        this.spentsedits.push({ ...gastoEditado });
        this.gastossubidos[index].edit = true;
      } else { 
        let duplicated = false;
        for (let i = 0; i < this.spentsedits.length; i++) {
          if (this.spentsedits[i].iddetallegasto === gastoEditado.iddetallegasto) {
            this.spentsedits[i] = gastoEditado;
            duplicated = true;
            this.gastossubidos[index].edit = true;
            break;
          }          
        }
        if (!duplicated) {
          this.spentsedits.push({ ...gastoEditado });
          this.gastossubidos[index].edit = true;
        }
      }
    },
    async sendEdit() {
      if (this.spentsedits.length == 0) {
        alert("No hay gastos para actualizar");
      } else if (this.checkRequiredEditFields()) {
        alert("Se esta tratando de enviar un gasto sin los datos requeridos.")
      } else {
        let dateTimeActual = new Date(Date.now());
        dateTimeActual.setHours(dateTimeActual.getHours() - 5);
        let data = []
        for (const gasto of this.spentsedits) {
          data.push({
            ...gasto,
            fechaactualizacion: dateTimeActual.toISOString(),
          })
        }
        let tableType = this.tableType;
        await editSpents(data, tableType);
        alert("Gastos actualizados");
        this.spentsedits = [];
        this.fecthExpenses();
      }
    },
    async fecthExpenses() {
      try {
        const info = {id: this.expense.maestroGasto, tableType: this.tableType};
        const response = await selectSpentDetailEdit(info);
        this.gastossubidos = response.data.map(gasto => gasto);
      } catch (error) {
        alert("Error al buscar gastos")
      }
    },
    activeNewTab() {
      this.activeTab = 1;
    },
    activeEditTab() {
      this.activeTab = 2;
    },
    async reloadPage() { // Recarga la pagina en caso de que el token haya caducado
      let ValidToken = await tokenValidation();
      try {
        if(typeof(ValidToken.data) == undefined) {
          window.location.reload();
        } else {
          this.correousuario = ValidToken.data;
        }
      } catch (error) {
        console.error("Error al validar token", error);
        window.location.reload();

      }
    },
    resetForm() {
      this.expense = {
        gastos: [],
        maestroGasto: null,
      };
      this.maestroGasto = [];
      this.ciudades = [];
      this.fetchCiudades();
      this.fecthGastos();
      this.reloadPage();
    },
    addGasto() {
      if (!this.expense.maestroGasto) {
        alert("No hay un gasto seleccionado");
      } else {
        this.expense.gastos.push({
          fechagasto: null,
          ciudad: [],
          desayuno: false,
          almuerzo: false,
          cena: false,
          observaciones: null,
          collapsed: false, // Estado de colapso
          responsable: '',
        });
      }      
    },
    removeGasto(index) {
      this.expense.gastos.splice(index, 1);
    },
    toggleCollapse(index) {
      this.expense.gastos[index].collapsed = !this.expense.gastos[index].collapsed;
    },
    toggleCollapseEdit(index) {
      this.gastossubidos[index].collapsed = !this.gastossubidos[index].collapsed;
    },
    async submitExpense() {
      if (!this.expense.maestroGasto || this.expense.gastos.length === 0) {
        alert("No hay datos en el formulario");
      } else if(this.checkRequiredFields() === true) {
        alert("Campo obligatorios sin llenar (*), revisar antes de enviar")
      } else if (this.checkRepeat()) {
        alert("Gasto repetido, revisar.")
      } else if (this.uploading) {
        alert("Cargando gastos, espere.")
      } else {
        try {
          this.uploading = true;
          let dateTimeActual = new Date(Date.now());
          dateTimeActual.setHours(dateTimeActual.getHours() - 5);
          // Añadir el total de gastos al objeto expense
          let expenseData = {
            ...this.expense,
            totaldss: this.totalDesayunos,
            totalass: this.totalAlmuerzos,
            totalcss: this.totalCenas,
            fechaActualizacion: dateTimeActual.toISOString(),
          };

          // Envía los datos al servidor
        
          await updateGCS2(expenseData);

          for (const gasto of this.expense.gastos) {
            expenseData = {
              ...this.expense,
              title: 2,
              idViaje: this.maestroGasto,
              ...gasto,
              fechaCreacion: dateTimeActual.toISOString(),
              fechaActualizacion: dateTimeActual.toISOString(),
            }
            await insertarDetalleGCS(expenseData);
            
          }
          alert('Gastos subidos con éxito');
          this.resetForm();
          
        } catch (error) {
          console.error('Error al subir los gastos:', error);
        } finally {
          this.uploading = false;
        }
      }
      
    },
    checkRequiredFields() {
      for (const gasto in this.expense.gastos) {
        if (this.expense.gastos[gasto].fechagasto === '' || this.expense.gastos[gasto].ciudad.length === 0 || (!this.expense.gastos[gasto].desayuno && !this.expense.gastos[gasto].almuerzo && !this.expense.gastos[gasto].cena)) {
          return true
        }
      }
      return false
    },
    checkRequiredEditFields() {
      for (const gasto in this.spentsedits) {
        if (this.spentsedits[gasto].fechagasto === '' || this.spentsedits[gasto].ciudad.length === 0 || (!this.spentsedits[gasto].desayuno && !this.spentsedits[gasto].almuerzo && !this.spentsedits[gasto].cena)) {
          return true
        }
      }
      return false
    },
    async fetchCiudades(query = '') {
      try {
        const cachedData = localStorage.getItem("dataCities");
        if (cachedData) {
          this.ciudades = JSON.parse(cachedData).map(ciudad => ({id: ciudad.id, nombreMunicipio: ciudad.nombreMunicipio}));
        } else {
          localStorage.removeItem("dataCities");
          if (query.length >= 0) {
            const response = await selectDepartamentos(query);
            const ciudades = response.data.map(ciudad => ({id: ciudad.codigomunicipio, nombreMunicipio: ciudad.nombredepartamento + ' - ' + ciudad.nombremunicipio}));
            // Guarda los datos en localStorage
            localStorage.setItem("dataCities", JSON.stringify(ciudades));
            this.ciudades = JSON.parse(localStorage.getItem("dataCities")).map(ciudad => ({id: ciudad.id, nombreMunicipio: ciudad.nombreMunicipio}));
          }
        }
      } catch (err) {
        console.error(err);
        window.location.reload();
      }
    },
    onCiudadSearch(search) {
      this.fetchCiudades(search);
    },
    async fecthGastos(query) {
      try {
        const response = await selectMaestroGastos(query);
        this.maestroGasto = response.data.map(gas => ({
          id: gas.idviaje,
          nombreviaje: gas.nombreviaje,
        }));
        if (!this.expense.maestroGasto && this.maestroGasto.length > 0) {
          this.expense.maestroGasto = this.maestroGasto[0].id;
          if (this.expense.maestroGasto) {
            this.addGasto();
          }
        }
      } catch (err) {
        console.error('Error obteniendo los gastos', err);
      }
    },
    onGastoSearch(search) {
      this.fecthGastos(search);
    },
  },
};
</script>